import React from "react";
import { DateTime } from "luxon";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { EditDateDialog } from "../core/EditDateDialog";
import { formatFullDate } from "../core/date-formatting";

/**
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.popupTitle]
 * @param {number} props.timestamp
 * @param {(newDate: number) => void} props.onSave
 * @param {boolean} props.isBusy
 * @param {boolean} [props.disablePast]
 * @param {boolean} [props.disableFuture]
 * @param {(date: number) => string} [props.formatter]
 * @param {string} [props.timezone]
 * @param {"date" | "datetime"} [props.mode]
 * @param {import("react").ReactNode} [props.children]
 */
export const EditableDate = ({
  title,
  popupTitle,
  timestamp = 0,
  onSave,
  isBusy,
  disablePast = false,
  disableFuture = false,
  formatter = (date) => formatFullDate(date),
  timezone = undefined,
  mode = "date",
  children,
}) => {
  return (
    <Box>
      <EditDateDialog
        onSave={onSave}
        title={popupTitle || title}
        isBusy={isBusy}
        initialValue={timestamp === 0 ? DateTime.now().toMillis() : timestamp}
        disablePast={disablePast}
        disableFuture={disableFuture}
        timezone={timezone}
        mode={mode}
        formatter={formatter}
      >
        {children || (
          <Stack>
            <Typography>{title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {timestamp === 0 ? "Click to edit." : formatter(timestamp)}
            </Typography>
          </Stack>
        )}
      </EditDateDialog>
    </Box>
  );
};
